import {
  SimpleGrid,
  Box,
  Text,
  Stack,
  useColorModeValue,
  Heading,
  Flex,
  AspectRatio,
  Container,
  Spinner,
  VStack,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import LinkListCard from "../components/LinkListCard";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga4";
const LinkList = () => {
  let { slug } = useParams();
  const myHeaders = new Headers();

  myHeaders.append("Content-Type", "application/json");
  const [data, setData] = useState<any>([]);
  const [link, setLink] = useState<any>("");
  const [loading, setLoading] = useState<boolean>(false);
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}headsup/getLinklist/${slug}`,
      {
        method: "GET",
        headers: myHeaders,
      }
    );
    const newData = await response.json();
    setData(newData);
  };
  ReactGA.initialize("G-Q5E5DTFPJD");
  ReactGA.send({
    hitType: "pageview",
    page: `/link/${slug}`,
    title: data.linkListData?.linkListTitle ?? "Headsup LinkList",
  });
  // linkListAuthor
  // :
  // "Narendra"
  // linkListAuthorID
  // :
  // "105827029423147926004"
  // linkListCategory
  // :
  // "HeadsUp Tasks"
  // linkListData
  // :
  // (5) [{…}, {…}, {…}, {…}, {…}]
  // linkListDescription
  // :
  // "Test Version"
  // linkListID
  // :
  // "linkListID"
  // linkListTags
  // :
  // "app development,react,learning"
  // linkListTitle
  // :
  // "Headsup Version 3 Linklist"
  // linkListURL
  // :
  // "URL"

  // headsUpCategory
  // :
  // "HeadsUp Tasks"
  // headsUpTime
  // :
  // "2024-02-13T01:29:49.619Z"
  // headsUpTitle
  // :
  // "Add Translations to Headsup"
  // headsUpURL
  // :
  // ""
  // headsUpUserID
  // :
  // "105827029423147926004"
  // __v
  // :
  // 0
  // _id
  // :
  // "65cac60df4902e691c964094"
  // console.log(data.linkListData?.linkListTitle)

  return (
    //   <Heading as={h1}>{data?.linkListTitle!}</Heading>
    <>
      <Helmet>
        <title>{data.linkListData?.linkListTitle ?? "Headsup"}</title>
        <meta
          name="keywords"
          content="Embedded Systems, Robotics, Internet of Things, Machine Learning, Python, Tech Sustainability, Electrical Engineering, Tata Consultancy Services, Florida State University"
        ></meta>

        <meta
          name="description"
          content={
            data.linkListData?.linkListDescription! ??
            "Collection of links by Headsup"
          }
        ></meta>
        <meta
          property="og:title"
          content={data.linkListData?.linkListTitle ?? "Headsup"}
        ></meta>
        <meta
          property="og:description"
          content={
            data.linkListData?.linkListDescription! ??
            "Collection of links by Headsup"
          }
        ></meta>
        <meta
          property="og:image"
          content="https://res.cloudinary.com/docn0mvoh/image/upload/v1708995003/screenshot-2_rvot5l.png"
        ></meta>
        <meta
          property="og:url"
          content="https://headsupapp.netlify.app/"
        ></meta>
        <meta
          name="twitter:card"
          content="https://res.cloudinary.com/docn0mvoh/image/upload/v1708995003/screenshot-2_rvot5l.png"
        ></meta>
        <meta
          name="twitter:title"
          content={data.linkListData?.linkListTitle ?? "Headsup"}
        ></meta>
        <meta
          name="twitter:description"
          content={
            data.linkListData?.linkListDescription! ??
            "Collection of links by Headsup"
          }
        ></meta>
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/docn0mvoh/image/upload/v1708995003/screenshot-2_rvot5l.png"
        ></meta>
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-Q5E5DTFPJD"
        ></script>
      </Helmet>
      <Box display={"flex"} h="100%" w="100%" pr={4}>
        <Box
          h="calc(100vh)"
          overflowY={"auto"}
          my={16}
          mx={16}
          w={"2xl"}
          css={{
            "&::-webkit-scrollbar": {
              width: "4px",
            },
            "&::-webkit-scrollbar-track": {
              width: "6px",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "gray.300",
              borderRadius: "24px",
            },
          }}
        >
          <Stack spacing={4}>
            <Text
              textTransform={"uppercase"}
              color={"blue.400"}
              fontWeight={600}
              fontSize={"sm"}
              bg={useColorModeValue("blue.50", "blue.900")}
              p={2}
              alignSelf={"flex-start"}
              rounded={"md"}
            >
              {data.linkListData?.linkListCategory}
            </Text>
            <Heading>{data.linkListData?.linkListTitle}</Heading>
            <Text as={"span"}>
              {" "}
              Curated By: {data.linkListData?.linkListAuthor!}
            </Text>
            <Text color={"gray.500"} fontSize={"lg"}>
              {data.linkListData?.linkListDescription!}
            </Text>
            <br />
            {data.headsUpData ? (
              <Flex direction={"column"} w={"full"} gap={2}>
                {data?.headsUpData?.map(
                  (
                    headsup: { headsUpTitle: any; headsUpURL: any },
                    idx: any
                  ) => (
                    <LinkListCard
                      key={idx}
                      setLink={setLink}
                      setLoading={setLoading}
                      header={headsup.headsUpTitle}
                      linkVal={headsup.headsUpURL}
                    />
                  )
                )}
              </Flex>
            ) : (
              <Flex direction={"column"} w={"full"} gap={2}>
                {data?.linkListData?.linkListData?.map(
                  (
                    headsup: { headsUpTitle: any; headsUpURL: any },
                    idx: any
                  ) => (
                    <LinkListCard
                      key={idx}
                      setLink={setLink}
                      setLoading={setLoading}
                      header={headsup.headsUpTitle}
                      linkVal={headsup.headsUpURL}
                    />
                  )
                )}
              </Flex>
            )}
          </Stack>
        </Box>
        <Box
          w={"70%"}
          h="calc(100vh)"
          justifyContent={"center"}
          alignItems={"center"}
        >
          {loading && (
            <VStack color={"teal"}>
              <Spinner color="colorPalette.600" />
              <Text color="colorPalette.600">Linst Preview is Loading...</Text>
            </VStack>
          )}
          <AspectRatio h="full" overflowY={"hidden"} flex={1}>
            <iframe
              title="linst"
              src={link}
              sandbox="allow-scripts allow-modal"
              allowFullScreen
              onLoad={() => setLoading(false)}
            />
          </AspectRatio>
        </Box>
      </Box>
    </>
  );
};
export default LinkList;
